import axios from 'axios';
import apiConfig from '../api.config';

export default function updateGuestlinkSmtpConfig({ hotelId, smtpConfig, applyToAllHotels }) {
  const {
    host,
    URIs: { updateGuestlinkSmtConfig },
  } = apiConfig;

  const uri = `${host}${updateGuestlinkSmtConfig.replace(':hotelId', hotelId)}?applyToAllHotels=${applyToAllHotels}`;

  return axios
    .put(uri, JSON.stringify({ smtpConfig }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
